'use client'

import { ArrowRight } from '@/components/svg/arrow-right/arrow-right'
import s from './supplier-offers-and-events-item.module.scss'
import { useModal } from '@/hooks/use-modal'

type Props = {
  title: string
  date: string
  description: string
  link?: string
}

export const SupplierOffersAndEventsItem = ({
  title,
  date,
  description,
  link,
}: Props) => {
  const modal = useModal()
  const showLink = link && link !== ''

  const handleOnClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation()
    e.preventDefault()

    modal.open('supplier-offers-and-events', {
      modalProps: {
        title,
        description,
        link: showLink ? link : undefined,
      },
    })
  }
  return (
    <button className={s.container} onClick={handleOnClick}>
      <div className={s.contentContainer}>
        <h3 className={s.title}>{title}</h3>
        <div className={s.dateContainer}>
          <p className={s.date}>{date}</p>
        </div>
      </div>
      <ArrowRight
        iconColor="#131313"
        svgProps={{
          width: 16,
          height: 16,
          style: { minHeight: 16, minWidth: 16 },
        }}
      />
    </button>
  )
}
